import { Auth } from '@aws-amplify/auth';
import { logErrorInfo } from '@/api';
import { ActionType } from '@/constants';
import store from '@/store';

const getAuthenticatedUser = () => Auth.currentAuthenticatedUser();

const getCurrentSession = () => Auth.currentSession();

const signIn = (username: string, password: string) => Auth.signIn(username, password);

const resetPassword = (email: string) => Auth.forgotPassword(email);

const verify = (user: any, newPassword: string) => Auth.completeNewPassword(
  user,
  newPassword
)
  .then(data => data);

const signOut = async () => {
  try {
    await store.dispatch(ActionType.UPDATE_SIGNIN_STATUS, false);
    await Auth.signOut();
    store.dispatch(ActionType.UPDATE_SELECTED_JOB, '');
    localStorage.clear();
  } catch (error) {
    await logErrorInfo(error);
  }
}

const updatePassword = (oldPassword: string, newPassword: string) => {
  return new Promise((resolve, reject) => {
    getAuthenticatedUser()
      .then(user => {
        return Auth.changePassword(user, oldPassword, newPassword);
      })
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

const getIdToken = () => {
  return new Promise((resolve, reject) => {
    getCurrentSession().then(res => {
      const accessToken = res.getIdToken().getJwtToken();
      resolve({ Authorization: `Bearer ${accessToken}` })
    }).catch((err) => {
      resolve({})
      return err;
    });
  });
}

const acceptTerms = (user: any, date: Date) => {
  Auth.updateUserAttributes(user, {
    'custom:acceptTerms': date
  });
}

const updateEmail = async (newEmail: string) => {
  const user = await getAuthenticatedUser();
  const result = await Auth.updateUserAttributes(user, {
    email: newEmail
  });
  return result;
}

export {
  signIn,
  verify,
  signOut,
  getIdToken,
  acceptTerms,
  updatePassword,
  resetPassword,
  getCurrentSession
};
